<template>
    <rkm-layout-body title="Alto custo - Gerenciamento de processo">
        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/farmacia/alto-custo-gerenciamento-processo/List'

export default {
    components: { List },
}
</script>